import { operations } from './../api/skippay/generated/selfCare';
import {
	operations as couponsOperations,
	paths as couponsPaths,
} from './../api/skippay/generated/couponsApi';

export const URLS = {
	accountConsent: '/account/consents',
	myProfile: '/my/profile',
	myContractSupportRequestCreate: '/my/contract/supportRequest',
	partners: '/partners',
	partnersCategories: '/partners/categories',
	customerDataRequestCreate: '/customer/request',
	customerDataRequestConfirmCreate: '/customer/request/confirm',
	remoteTranslations: (lng: string) => `/dynamic-translations/${lng}`,
	publicRewards: '/public/rewards/partnerPromocodes/offers',
	publicInstallmentsCalculator: '/public/installments/options',
	publicInstallmentsRPSN: '/public/installments/rpsn',
	publicUpsellServicesPriceCalculator: '/public/upsellServices/priceCalculator',
	exchangeRates: (args: operations['exchangeRates']['parameters']['path']) =>
		`/exchangeRates/${args.date}`,
	exchangeRatesMarkups: (args: operations['ecbExchangeRateMarkups']['parameters']['path']) =>
		`/ecbExchangeRateMarkups/${args.date}`,
	questionnaire: (args: operations['myProfileQuestionnaire']['parameters']['path']): string =>
		`/my/profile/questionnaire/${args.id}`,
	questionnaireCreate: (
		args: operations['myProfileQuestionnaireSurveyCreate']['parameters']['path']
	): string => `/my/profile/questionnaire/${args.id}/survey`,
	questionnaireChange: (
		args: operations['myProfileQuestionnaireSurveyChange']['parameters']['path']
	): string => `/my/profile/questionnaire/${args.id}/survey/${args.surveyId}`,
	publicUpsellServicesClaims: '/public/upsellServices/claims',
};

export const COUPONS_URLS = {
	categoriesList: '/categories',
	couponDetail: (args: couponsOperations['couponDetail']['parameters']['path']): string =>
		`/coupon/${args.id}`,
	couponsList: '/coupons',
	merchantsList: '/merchants',
} satisfies Record<
	keyof couponsOperations,
	keyof couponsPaths | ((args: couponsOperations['couponDetail']['parameters']['path']) => string)
>;

export const GCSS_URLS = {
	productList: '/products',
	categoryList: '/categories',
	brandList: '/brands',
	merchantsList: '/merchants',
};
